<template>
    <div>
        <b-form-group>
            <label class="mr-2" for="">Potongan Tambahan</label>
            <div v-if="optPotonganTambahan.length == 0" class="text-muted">
                Tidak ada Potongan dari jenis barang yang dipilih.
            </div>
            <b-form-checkbox-group class="checkbox-group" v-else v-model="input.potonganTambahan" name="potonganTambahan">
                <div class="d-block" v-for="item in optPotonganTambahan" v-bind:key="item.id">
                    <b-form-checkbox :value="item.id">
                        {{ item.name }}
                    </b-form-checkbox>
                </div>
            </b-form-checkbox-group>
        </b-form-group>
    </div>
</template>
<script>
export default {
    props: {
        input: { required: true },
        optPotonganTambahan: { required: true },
    },
}
</script>